import React, { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Header from '../../components/Header2/Header2';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const BlogDetailsPage = () => {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`https://strapi.ppl.co.id/api/newses?filters[Slug][$eq]=${slug}&populate=*`)
            .then(res => res.json())
            .then(result => {
                if (result.data && result.data.length > 0) {
                    setBlog(result.data[0]);
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("Error:", err);
                setLoading(false);
            });
    }, [slug]);

    if (loading) return (
        <Fragment>
            <Header />
            <div style={{padding: '150px', textAlign: 'center'}}>Loading...</div>
            <Footer />
        </Fragment>
    );

    if (!blog) return (
        <Fragment>
            <Header />
            <div style={{padding: '150px', textAlign: 'center'}}>Berita tidak ditemukan!</div>
            <Footer />
        </Fragment>
    );

    const mediaList = blog.Media || [];

    const sliderSettings = {
        dots: true,
        infinite: mediaList.length > 1, // Fix biar nggak nge-clone kalau gambar cuma 1
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
    };

    return (
        <Fragment>
            <Header />
            <main className="page_content blog-details-page">
                {/* PageTitle dinamis ngambil dari judul artikel */}
                <PageTitle pageTitle={blog.Title} pagesub={'Blog Details'} pageTop={'Blog'}/>
                {/* Padding atas dikurangin karena udah ada PageTitle */}
                <div className="container" style={{paddingTop: '50px', paddingBottom: '100px'}}>
                    <div style={{ marginBottom: '30px' }}>
                        <Slider {...sliderSettings}>
                            {mediaList.map((mediaItem, index) => {
                                // Bikin URL-nya dulu
                                const mediaUrl = `https://strapi.ppl.co.id${mediaItem.url}`;
                                // Cek apakah filenya video berdasarkan mime type atau ekstensi
                                const isVideo = mediaItem.mime ? mediaItem.mime.startsWith('video/') : mediaUrl.match(/\.(mp4|webm|ogg)$/i);

                                return (
                                    <div key={index} className="slider-item-wrapper">
                                        {isVideo ? (
                                            // Render video player
                                            <video
                                                controls
                                                className="slider-video shadow-sm"
                                                style={{ width: '55%', borderRadius: '10px', maxHeight: '400px', backgroundColor: '#000' }}
                                            >
                                                <source src={mediaUrl} type={mediaItem.mime || 'video/mp4'} />
                                                Browser lu nggak support tag video bray.
                                            </video>
                                        ) : (
                                            // Render gambar biasa
                                            <img
                                                src={mediaUrl}
                                                alt={blog.Title}
                                                className="slider-image shadow-sm"
                                                style={{ width: '100%', borderRadius: '10px', objectFit: 'cover' }}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                    <h1>{blog.Title}</h1>
                    <div className="blog-content" style={{marginTop: '30px'}}>
                        {blog.Content && blog.Content.map((paragraph, index) => (
                            <p key={index}>
                                {paragraph.children && paragraph.children.map((child, childIndex) => (
                                    <span key={childIndex}>{child.text}</span>
                                ))}
                            </p>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
}

export default BlogDetailsPage;
